import { Flex } from "antd";

export const RowComponent = ({ children, style = {}, ...props }) => {
  return (
    <Flex
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        ...style,
      }}
      {...props}
    >
      {children}
    </Flex>
  );
};
